import React, { useState } from 'react';
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@material-ui/core';
import MultiDatePicker from '../../../../components/DatePickers/MultiDatePicker';
import { Loader, colors } from 'kangarootime-ui';

const CopyShift = ({ isOpen, dismiss, copyShift, performingAction }) => {
  const [selectedDates, setSelectedDates] = useState([]);

  return (
    <Dialog open={isOpen} onClose={dismiss}>
      <DialogTitle>Copy Shift to the following dates</DialogTitle>
      <DialogContent>
        <MultiDatePicker
          disableWeekends
          date={new Date()}
          onChange={dates => setSelectedDates(dates)}
        />
      </DialogContent>
      <Loader loading={performingAction}>
        <DialogActions>
          <Button onClick={dismiss}>
            Cancel
          </Button>
          <Button onClick={() => copyShift(selectedDates)} style={{ color: selectedDates.length === 0 ? colors.athensGray : colors.success }} disabled={selectedDates.length === 0}>
            Save
          </Button>
        </DialogActions>
      </Loader>
    </Dialog>
  );
};

export default CopyShift;
